var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.isMobile ? 'NavigationMobile' : 'NavigationDesktop', {
    tag: "component",
    attrs: {
      "active": _vm.active
    },
    on: {
      "close": _vm.onClose
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }